import type {IMfeService} from "./IMfeService";
import type {ApiReturnMfe} from "@highimpact-frontend/api-types";
import {api_config} from "../../../api-commons";

class MfeService implements IMfeService {
    async getMfes(): Promise<ApiReturnMfe[]> {
        const response = await api_config.get('/mfes');
        return response.data;
    }
}
const instance = new MfeService();
export default instance;
